/* eslint-disable no-nested-ternary */
import isEmpty from 'lodash/isEmpty';
import entity from './entity';
import {
  merge,
} from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import { TYPES } from './actions';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
  pagination: {
    pageSize: 15,
    pageNumber: 1,
    hasMore: false,
    totalElements: 0,
  },
  unseenCount: {
    value: 0,
    isLoading: false,
    error: null,
  },
  markAsSeen: {
    isLoading: false,
    error: null,
  },
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.GET_UNSEEN_NOTIFICATIONS_COUNT_REQUEST:
      return merge(state, {
        unseenCount: {
          ...state.unseenCount,
          isLoading: true,
        },
      });
    case TYPES.GET_UNSEEN_NOTIFICATIONS_COUNT_SUCCESS:
      return merge(state, {
        unseenCount: {
          ...state.unseenCount,
          isLoading: false,
          value: action.payload,
        },
      });
    case TYPES.GET_UNSEEN_NOTIFICATIONS_COUNT_ERROR:
      return merge(state, {
        unseenCount: {
          isLoading: false,
          value: 0,
          error: action.payload,
        },
      });
    case TYPES.GET_ALL_REQUEST:
      if (action.payload.page === 1) {
        return merge(state, {
          isLoading: true,
          data: {},
          error: null,
          pagination: {
            ...INITIAL_STATE.pagination,
          },
        });
      }
      return merge(state, {
        isLoading: true,
        error: null,
      });
    case TYPES.GET_ALL_REQUEST_SUCCESS:
      return merge(state, {
        isLoading: false,
        data: merge(state.data, action.payload.content),
        pagination: {
          ...state.pagination,
          pageNumber: action.payload.size > state.pagination.pageSize
            ? (action.payload.size % state.pagination.pageSize !== 0)
              ? (action.payload.size / state.pagination.pageSize) + 1
              : action.payload.size / state.pagination.pageSize
            : action.payload.number + 1,
          hasMore: !action.payload.last,
          totalElements: action.payload.totalElements,
        },
      });
    case TYPES.GET_ALL_REQUEST_ERROR:
      return merge(state, {
        isLoading: false,
        data: {},
        error: isEmpty(action.payload) || action.payload,
      });
    case TYPES.MARK_NOTIFICATION_SEEN_REQUEST:
      return merge(state, {
        markAsSeen: {
          ...state.markAsSeen,
          isLoading: true,
        },
      });
    case TYPES.MARK_NOTIFICATION_SEEN_ERROR:
      return merge(state, {
        markAsSeen: {
          isLoading: false,
          error: action.payload,
        },
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
